module.exports = {"id":"tight-eyez-krump-basics","title":"Tight Eyez's Krump Basics","author":"Tight Eyez","style":"krump","language":"en","thumbnail":"https://i.ytimg.com/vi/9rVaELJHSIg/mqdefault.jpg","sections":[{"title":"Krump Basics","videos":[{"youtubeId":"9rVaELJHSIg","duration":"PT1H30M8S","title":"Part 1 of 3","height":344,"width":459},{"youtubeId":"M65objaBotc","duration":"PT1H17M40S","title":"Part 2 of 3","height":344,"width":459},{"youtubeId":"g8VyX_Aq_3U","duration":"PT1H29M24S","title":"Part 3 of 3","height":344,"width":459}]}]}


//////////////////
// WEBPACK FOOTER
// ../common/js/tutorials/playlists/krump/tighteyes.json
// module id = PPtY
// module chunks = 0 1